import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

// Season pass / membership products bought on the account in the year, with
// money from purchase_ledger split per pass and the house profit estimate.
export const GET_ANNUAL_PERFORMANCE = gql`
  query GetAnnualPerformanceTable($input: GetEventPerformanceInput!) {
    getAnnualPerformanceV2(input: $input) {
      ticket_id
      name
      type
      passes_sold
      app_sales
      pos_card_sales
      pos_cash_sales
      profit
      avg_profit
    }
  }
`;

export function useGetAnnualPerformance(account_id, year) {
  const { data, loading, error } = useQuery(GET_ANNUAL_PERFORMANCE, {
    variables: { input: { account_id, year } },
    fetchPolicy: 'no-cache',
    skip: !account_id || !year,
  });

  return { data, loading, error };
}
